import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import api from 'services/api.js';
import { serverApi } from 'services/constante.js';
import Modal from '@material-ui/core/Modal';
import { TextField } from "@mui/material";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { sendTestMessage, sendWhatsAppMessage } from 'services/whatsappConfig.js';


function getModalStyle() {

    const top = 50;
    const left = 50;
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: 'absolute',
      width: 800,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    btnEnviar: {
      backgroundColor: 'transparent',
      color: '#000',
      border: '1px solid #000',
    }
  }));

  export default function ModalConfirmacaoAceiteContratoVenda({open, aceitarContrato}) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    const [codigo, setCodigo] = useState(Math.floor(1000 + Math.random() * 9000));
    const [user, setUser] = useState(null);
    const [codigoUser, setCodigoUser] = useState(null);
    //const [open, setOpen] = React.useState(true);
    
    useEffect(() => {
      if(open) {
        carregaUsuario();
      }
    }, [open]);

    useEffect(() => {
      if (user) {
        // Chama automaticamente a função de teste do WhatsApp
        //sendTestWhatsAppMessage();
        sendWhatsAppMessage(api, user.Telefone, codigo);
      }
    }, [user]);


    async function carregaUsuario() {
      const response = await api.get(serverApi.url + serverApi.versao + '/Usuario/Perfil');
      const userProfile = response.data;
      setUser(userProfile);
    }

    async function sendCode() {
        if(codigo == null || codigo == "") {
            return;
        }

        if(user == null) {
            return;
        }

        if(user.Email != null && user.Email != "") {
          let data = JSON.stringify({
            "email": user.Email,
            "conversion": "Contrato_Validacao_Assinatura",
            "name": user.Nome,
            "codigo_assinatura_contrato": codigo
          });
          
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: serverApi.urlN8N + '/send-lead-rd-station',
            headers: { 
              'x-api-key': '136DBA15429AE6535AF879B978CB4', 
              'Content-Type': 'application/json'
            },
            data: data
          };

          await api(config).then(responseS => {
            //console.log("responseS", responseS);
          })
          .catch(error => {
              console.error(error);
          })
          .finally(() => { });
          
        }

        if(user.Telefone != null && user.Telefone != "") {
          let data = JSON.stringify({
            "number": user.Telefone,
            "msg": "Olá, "+ user.Nome + "!\n\nSeu código de autenticação para assinatura do contrato é: *" + codigo + "*"
          });
          
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: serverApi.urlN8N + '/envia-msg-wp-notificacao',
            headers: { 
              'x-api-key': '136DBA15429AE6535AF879B978CB4', 
              'Content-Type': 'application/json'
            },
            data : data
          };

          await api(config).then(responseS => {
            //console.log("response WP", responseS.data);
          })
          .catch(error => {
              console.error(error);
          })
          .finally(() => { });
          
        }
    }

    // Função para enviar mensagem de teste para WhatsApp
    async function sendTestWhatsAppMessage() {
        try {
            const result = await sendTestMessage(api);
            
            if (result.success) {
                console.log("Mensagem de teste enviada com sucesso:", result.data);
                alert("Mensagem de teste enviada com sucesso!");
            } else {
                console.error("Erro ao enviar mensagem de teste:", result.error);
                alert("Erro ao enviar mensagem de teste: " + result.error);
            }
            
        } catch (error) {
            console.error("Erro ao enviar mensagem de teste:", error);
            alert("Erro ao enviar mensagem de teste: " + error.message);
        }
    }

    async function validateCode() {
      if(codigoUser == null || codigoUser == "") {
        return;
      }

      if(codigoUser != codigo) {
        alert("Código inválido");
        return;
      }

      aceitarContrato();
    }

    /* const handleOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    }; */
  
    const body = (
      <div style={modalStyle} className={classes.paper}>
        <h2 id="simple-modal-title">Confirmação de aceite do contrato</h2>
        <p id="simple-modal-description">Enviamos um código de autenticação no seu e-mail e no WhatsApp</p>
        <GridContainer>
            <GridItem xs={6} sm={6} md={6}>
                <TextField
                    id="Codigo_Autenticacao"
                    name="codigo"
                    label="Código de autenticação"
                    margin="dense"
                    type="number"
                    defaultValue={codigoUser}
                    onChange={(e) => setCodigoUser(e.target.value)}
                    fullWidth
                    inputProps={{ maxLength: 4 }}
                    required
                />
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <Button onClick={validateCode} className={classes.btnEnviar}>{"Enviar"}</Button>
            </GridItem>
        </GridContainer>
        

      </div>
    );
  
    return (
      <div>
        <Modal
          open={open}
          //onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {body}
        </Modal>
      </div>
    );
  }